import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import {Store, select} from '@ngrx/store';
import {Observable} from 'rxjs';
import * as fromAuthStore from '@app/auth/store';
import * as fromNotificationStore from '@app/notifications/store';
import {CoreService} from '@app/core/services';
import {TranslateService} from '@ngx-translate/core';
import {Event, NavigationStart, Router} from '@angular/router';
import { TRole} from 'src/utils/declarations';
import {AuthService} from '@app/auth/services';
import {
  HEADER_MENU_ITEMS,
  ITextByRole,
  KRONAS_MAIN_URL,
  KRONAS_MASTER_URL,
  LANGS,
  NEW_PERSONAL_URL,
} from 'src/utils/constants';
import {LanguageCode} from 'src/utils/enums';
import {INotificationsWindowInfo} from '@app/notifications/store/reducers/notifications.reducers';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  showMobMenu = false;
  showNotifications = false;
  showLangs = false;
  showUserInfo = false;
  LanguageCodes = LanguageCode;
  activeLanguage = LanguageCode.UK;
  rolesLoaded$: Observable<any>;
  currentUser$: Observable<any>;
  menuItems = HEADER_MENU_ITEMS;
  langs = LANGS;
  links = {
    master: KRONAS_MASTER_URL,
    main: KRONAS_MAIN_URL,
    newPersonal: `${NEW_PERSONAL_URL}/home`,
  };

  public notificationsInfo$: Observable<INotificationsWindowInfo> =
    this.notificationsStore.pipe(select(fromNotificationStore.getWindowInfo));

  @ViewChild('userSubmenu') submenu: ElementRef;
  @ViewChild('userSubmenuMob') submenuMob: ElementRef;
  @ViewChild('notificationsWindow') notificationsWindow: ElementRef;
  @ViewChild('langSubmenu') langSubmenu: ElementRef;
  @ViewChild('userSubmenu') userSubmenu: ElementRef;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: any): void {
    if (
      !this.submenuMob?.nativeElement.contains(event.target) &&
      !this.submenu?.nativeElement.contains(event.target) &&
      !this.notificationsWindow?.nativeElement.contains(event.target) &&
      !this.langSubmenu?.nativeElement.contains(event.target) &&
      !this.userSubmenu?.nativeElement.contains(event.target)
    ) {
      this.showNotifications = false;
      this.showLangs = false;
      this.showUserInfo = false;
    }
  }

  constructor(
    private authStore: Store<fromAuthStore.State>,
    private translate: TranslateService,
    private coreService: CoreService,
    private notificationsStore: Store<fromNotificationStore.State>,
    private router: Router,
    private authService: AuthService
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        const bodyElement = document.body;
        if (bodyElement) {
          bodyElement.style.overflowY = '';
        }
      }
    });
  }

  ngOnInit(): void {
    this.activeLanguage = this.coreService.getLocale();
    this.translate.use(this.activeLanguage);
    if (this.authService.getToken()) {
      this.notificationsStore.dispatch(
        new fromNotificationStore.GetWindowNotifications({
          page: 1,
          per_page: 6,
          read: false,
          token: this.authService.getToken(),
        })
      );
    }
    this.currentUser$ = this.authStore.select(fromAuthStore.getUser);
    this.rolesLoaded$ = this.authStore.select(fromAuthStore.getRolesLoaded);
  }

  ngAfterViewInit(): void {
    // subscribe on changing count unread notifications in store
    this.notificationsStore
      .pipe(select(fromNotificationStore.getNotificationsState))
      .subscribe((state) => {
        if (state.window.addedNewNotification) {
          this.notificationsStore.dispatch(
            new fromNotificationStore.GetWindowNotifications({
              page: 1,
              per_page: 6,
              read: false,
              token: this.authService.getToken(),
            })
          );
        }
      });
  }

  logout() {
    this.authStore.dispatch(new fromAuthStore.Logout());
  }

  toggleBurgerMenu() {
    this.showMobMenu = !this.showMobMenu;

    const bodyElement = document.body;

    if (bodyElement && this.showMobMenu) {
      bodyElement.style.overflowY = 'hidden';
    }

    if (bodyElement && !this.showMobMenu) {
      bodyElement.style.overflowY = '';
    }
  }

  changeLanguage(language: LanguageCode) {
    this.activeLanguage = language;
    this.translate.use(language);
    this.coreService.setLocale(language);
    this.coreService.getAddLocale();
  }

  checkMenuItemByUserRole(user: any, roles: TRole[]) {
    if (!roles.length) return true;

    if (roles.length === 1) {
      return user?.roles?.includes(roles[0]);
    }

    return roles.some((role) => user?.roles?.includes(role));
  }

  setTextOfMenuItemByUserRole(user: any, textByRole: ITextByRole[]): string {
    if (textByRole.length === 1) return textByRole[0].value;

    const linkText = textByRole.find((text) =>
      user?.roles?.includes(text.role)
    )?.value;

    // if I didn't look for linkText, I take default value (role: "")
    if (!linkText) {
      return textByRole.find((text) => !text.role)?.value as string;
    }

    return linkText;
  }

  getLanguageName(lang: LanguageCode) {
    switch (lang) {
      case LanguageCode.PL:
        return 'PL';
      case LanguageCode.EN:
        return 'EN';
      case LanguageCode.SK:
        return 'SK';
      case LanguageCode.UK:
        return 'UA';
      default:
        return 'UA';
    }
  }
}
